import Vue from 'vue';

export const Comments = Vue.component(
    'Comments',
    require('~/components/Comments/Comments.vue').default
);

export const PipelineMonitor = Vue.component(
    'PipelineMonitor',
    require('~/components/PipelineMonitor/PipelineMonitor.vue').default
);

export const LiveMonitor = Vue.component(
    'LiveMonitor',
    require('~/components/LiveMonitor/LiveMonitor.vue').default
);

export const AnalyticsDashboard = Vue.component(
    'AnalyticsDashboard',
    require('~/components/AnalyticsDashboard/AnalyticsDashboard.vue').default
);

export const PredictionManagement = Vue.component(
    'PredictionManagement',
    require('~/components/PredictionManagement/PredictionManagement.vue').default
);

export const KpiMonitor = Vue.component(
    'KpiMonitor',
    require('~/components/KpiMonitor/KpiMonitor.vue').default
);
